import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

export interface SimpleFormSchema {
  name: string
  /** é»è®¤ä¸º name */
  label?: string
  required?: boolean
  type?: 'i18nInput' | 'input' | 'textarea' | 'password' | 'checkbox' | 'select'
  placeholder?: string
  options?: string[]
  showIf?: () => boolean
}

@Component({
  selector: 'simple-form',
  templateUrl: './simple-form.component.html',
  styleUrls: ['./simple-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleFormComponent implements OnInit {

  @Input() schemas: SimpleFormSchema[] = []
  @Input() valueObject = {}
  /** å¯ç æ¾ç¤ºä¸ºå¯éç½®ç¶æï¼ç¼è¾æ¶å¯ä½¿ç¨ */
  @Input() passwordToBeReset = false

  @Output() init = new EventEmitter()

  @ViewChild('form') form

  constructor() { }

  ngOnInit() {
    this.init.emit(this)
  }

  isValid () {
    console.log(this.form && this.form.valid)
    return this.form && this.form.invalid
  }

}
